// Common constants and configurations for User KPI Management

export const USER_KPI_ROUTE_ID = 36;

// Table column definitions
export const TABLE_COLUMNS = [
    { id: 'userName', label: 'User Name', sortable: true, minWidth: 200 },
    { id: 'periodName', label: 'Period', sortable: true, minWidth: 150 },
    { id: 'designationAtAssignment', label: 'Designation', sortable: false, minWidth: 180 },
    { id: 'goalsCount', label: 'Goals', sortable: true, minWidth: 100 },
    { id: 'score', label: 'Score', sortable: true, minWidth: 150 },
    { id: 'updatedBy', label: 'Updated By', sortable: false, minWidth: 200 },
    { id: 'updatedAt', label: 'Updated At', sortable: true, minWidth: 150 },
    { id: 'actions', label: 'Actions', sortable: false, minWidth: 150 }
];

// Pagination options
export const ROWS_PER_PAGE_OPTIONS = [
    { label: '10', value: 10 },
    { label: '25', value: 25 },
    { label: '50', value: 50 },
    { label: '100', value: 100 }
];

// API endpoints
export const API_ENDPOINTS = {
    ASSIGN: '/kpi/user-kpi/assign',
    GET_ALL: '/kpi/user-kpi/get/all',
    GET_BY_ID: '/kpi/user-kpi/get',
    GET_WITH_GOALS: '/kpi/user-kpi/get/user/:userId/period/:periodId',
    DELETE: '/kpi/user-kpi/delete',
    UPDATE_USER_KPI: '/kpi/user-kpi/update',
    ADD_GOAL: '/kpi/user-kpi/:id/goals/add',
    UPDATE_GOAL: '/kpi/user-kpi/:userKpiId/goals/update/:goalId',
    UPDATE_MULTIPLE_GOALS: '/kpi/user-kpi/:id/goals/update-multiple',
    REMOVE_GOAL: '/kpi/user-kpi/:userKpiId/goals/remove/:goalId',
    GET_GOALS: '/kpi/user-kpi/:id/goals',
    // Score Management
    GET_SCORES_BY_USER_KPI: '/kpi/user-kpi-goal-score/by-user-kpi',
    CREATE_BULK_SCORES: '/kpi/user-kpi-goal-score/create-bulk',
    CREATE_SCORE: '/kpi/user-kpi-goal-score/create',
    UPDATE_SCORE: '/kpi/user-kpi-goal-score/update',
    DELETE_SCORE: '/kpi/user-kpi-goal-score/delete'
};

// Form field validation
export const VALIDATION_RULES = {
    userId: {
        required: 'User is required',
        pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: 'Please enter a valid email address'
        }
    },
    periodId: {
        required: 'Period is required'
    },
    templateId: {
        required: false // Optional, can create without template
    },
    goals: {
        required: 'At least one goal is required',
        validate: {
            totalWeight: (goals) => {
                const total = goals.reduce((sum, g) => sum + (Number(g.weight) || 0), 0);
                return total === 100 || 'Total weight must equal 100%';
            }
        }
    }
};

// Default form values
export const DEFAULT_FORM_VALUES = {
    userId: '',
    periodId: '',
    templateId: null,
    manualGoals: []
};

// Goal form defaults
export const DEFAULT_GOAL_VALUES = {
    goalId: '',
    category: '',
    weight: 0,
    score: null,
    remark: ''
};

// Date format for display
export const DISPLAY_DATE_FORMAT = 'MMM DD, YYYY';

// Error message extraction utility
export const getErrorMessage = (error, defaultMessage) => {
    // Prioritize API response message if it's a string
    if (error?.response?.data?.message && typeof error.response.data.message === 'string') {
        return error.response.data.message;
    }
    // Fall back to error message
    if (error?.message) {
        return error.message;
    }
    // Use default message
    return defaultMessage;
};
